import AbstractWebRtcListenerAction from "./AbstractWebRtcListenerAction";
import AbstractWebRtcCall from "~/ts/library/webRtc/AbstractWebRtcCall";

export default class WebRtcCallReceiveAnswer extends AbstractWebRtcListenerAction {
    getAction(): string {
        return "webRtcCallReceiveAnswer";
    }

    onAction(payload: CometOperatorApplication.WebRtcCallReceiveAnswerCometMessageOpenApiModel): void {
        let currentCall = AbstractWebRtcCall.getCurrentCall();
        if (currentCall?.getId() == payload.call.id) {
            currentCall.setCallData(payload.call);
            currentCall.receiveAnswer(payload.pairId, payload.answer!);
        }
    }

}